import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, map, switchMap, takeUntil } from 'rxjs';

import { User } from '../../auth/models/user.model';
import { LoginService } from '../../auth/services/login.service';
import { ComponentCommService } from '../../services/component-comm.service';
import { MarketService } from '../../services/market.service';
import { SubscriptionManager } from '../../utilities/subscription-manager';
import { HTMLToClipboardService } from '../../ui/services/html-to-clipboard.service';

/**
 * Documents is the component in charge of displaying the documentation of the
 * specific platform of each market, including the Terms and Conditions,
 * Privacy Policies, etc.
 */
@Component({
  selector: 'documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent extends SubscriptionManager implements OnInit, OnDestroy {

  public marketId: string;
  public documentType: string;
  public documentsList: any;
  /** The language currently used. */
  public currentLang: string;

  // Observables for async pipe
  public user$: Observable<User>;
  public marketsByType$: Observable<Array<any>>;
  public viewData$: Observable<{ user: User; marketsByType: Array<any> }>;

  /** @ignore */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private marketService: MarketService,
    private loginService: LoginService,
    private componentComm: ComponentCommService,
    public htmlClipboardService: HTMLToClipboardService,
    private translateService: TranslateService
  ) {
    super();
    this.documentsList = {
      'terms': 'GLOBAL.TERMS_AND_CONDITIONS',
      'privacy': 'GLOBAL.PRIVACY_POLICY',
      // 'user-manual': 'GLOBAL.USER_MANUAL',
      // 'fees': 'GLOBAL.FEES'
    };
  }

  ngOnInit(): void {
    this.currentLang = this.translateService.currentLang;

    // Setup observables
    this.route.params.pipe(
      map(params => {
        if (this.documentsList[params.documentType]) {
          this.marketId = params.marketId;
          this.documentType = params.documentType;
          this.componentComm.emit({ name: 'app-title', title: this.documentsList[this.documentType] });
        } else {
          // If slug does not exists, defaults to terms
          this.router.navigate(['documents', 'terms', params.marketId]);
        }
        return params;
      }),
      takeUntil(this.destroy$)
    ).subscribe();

    this.user$ = this.loginService.getCurrentUser();
    this.marketsByType$ = this.marketService.getMarketsByType();

    this.viewData$ = this.user$.pipe(
      switchMap(user =>
        this.marketsByType$.pipe(
          map(marketsByType => ({ user, marketsByType }))
        )
      )
    );
  }

  public goto(id): void {
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  }

  /** @ignore */
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
